import { Component, OnInit, OnDestroy, ElementRef, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { LucideAngularModule } from 'lucide-angular';
import { Subscription } from 'rxjs';
import { HeaderComponent } from '../../components/header/header.component';
import { FooterComponent } from '../../components/footer/footer.component';
import { HeroBannerComponent } from '../../components/hero-banner/hero-banner.component';
import { RestaurantCardComponent } from '../../components/restaurant-card/restaurant-card.component';
import { CartService } from '../../services/cart.service';
import { restaurants, offers, Offer } from '../../data/mock';
import { MatrixDto } from '../../Model/matrix-dto';
import { ApiFactoryEndPoints } from '../../common/api-factory-end-points';
import { FileServiceService } from '../../services/file-service.service';
import { ProductGroupWithIdAndName } from '../../Model/product-group-with-id-and-name';
import { Product } from '../../Model/product';
import { ProductSubGroup } from '../../Model/product-sub-group';
import { GoogleCustomer } from '../../Model/googlecustomer';
import { LocalStorageService } from '../../services/local-storage.service';
import { ProductService } from '../../services/product.service';
import { CommonExternalModule } from '../../common/common-external-module';
import { ToastService } from '../../services/toast.service';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [CommonExternalModule,
    HeaderComponent,
    FooterComponent,
    HeroBannerComponent,
    RestaurantCardComponent
  ],
  templateUrl: './home.component.html',
  styleUrl: './home.component.css'
})

export class HomeComponent implements OnInit, OnDestroy {

  restaurants = restaurants;
  offers = offers;
  cartCount = 0;
  currentUrl: string = '';
  showLeft = false;
  showRight = false;
  storeLatitudeMap: number | null = null;
  storeLongitudeMap: number | null = null;

  matrixList: MatrixDto[] = [];
  allGroupList: ProductGroupWithIdAndName[] = [];
  allSubGroupList: ProductSubGroup[] = [];
  allProductList: Product[] = [];
  productList: Product[] = new Array(1200);
  cartList: Product[] = [];
  googleCustomer = new GoogleCustomer();

  // @ViewChild('offersContainer') offersContainer!: ElementRef;

  //Subscription
  private cartSubscription!: Subscription;
  private cartSetUpSubscription: Subscription;
  private getAggregatorSetupSubscription: Subscription;

  constructor(
    private cartService: CartService,
    private apiFactory: ApiFactoryEndPoints,
    private fileService: FileServiceService,
    private localStorage: LocalStorageService,
    public productService: ProductService,
    private toastService: ToastService
  ) { }

  ngOnInit() {
    this.currentUrl = window.location.host.replace(':', '');
    this.getAllProducts();
    this.setCurrentLocationStore();
  }

  ngAfterViewInit() {
    // this.checkScrollButtons();
  }

  ngOnDestroy() {
    if (this.cartSubscription) {
      this.cartSubscription.unsubscribe();
    }

    if (this.cartSetUpSubscription) {
      this.cartSetUpSubscription.unsubscribe();
    }

    if (this.getAggregatorSetupSubscription) {
      this.getAggregatorSetupSubscription.unsubscribe();
    }
  }

  getAllProducts() {
    this.matrixList = this.fileService.getFileData("matrixList");
    this.allGroupList = this.fileService.getFileData("allGroupList");
    this.allProductList = this.fileService.getFileData("allProductList");
    this.matrixList.forEach(e => e.groupList = this.allGroupList.filter((f) => f.productMatrixCode == e.refNo));
    this.allProductList.forEach(element => {
      if (!this.allSubGroupList.some(e => e.refNo == element.productSubGroup.refNo)) {
        this.allSubGroupList.push(element.productSubGroup)
      }
    });
    this.productList = this.allProductList;
    this.matrixList.forEach(m => {
      restaurants.forEach(r => {
        if (m.productMatrixName == r.name) {
          r.id = m.refNo;
        }
      })
    })
    // this.matrixList.forEach(m => {
    //   const matchedRestaurant = restaurants.find(r => r.name === m.productMatrixName);
    //   if (matchedRestaurant) {
    //     matchedRestaurant.id = m.refNo;
    //   }
    // });
    this.getCartProduct();
  }

  private setCurrentLocationStore(): void {
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          // Location permission granted, get coordinates
          this.storeLatitudeMap = position.coords.latitude;
          this.storeLongitudeMap = position.coords.longitude;

          // Call API with the fetched location
          this.getAggregatorSetup();
        },
        (error) => {
          // Handle errors
          switch (error.code) {
            case error.PERMISSION_DENIED:
              this.toastService.showErrorToast('Location permission denied. Please allow location access in your browser settings.');
              break;
            case error.POSITION_UNAVAILABLE:
              this.toastService.showErrorToast('Location information is unavailable. Please try again later.');
              break;
            case error.TIMEOUT:
              this.toastService.showErrorToast('The request to get user location timed out. Please try again.');
              break;
            default:
              this.toastService.showErrorToast('An unknown error occurred. Please try again.');
              break;
          }

          // Call API with null latitude & longitude (Location disabled case)
          this.storeLatitudeMap = null;
          this.storeLongitudeMap = null;
          this.getAggregatorSetup();
        },
        {
          enableHighAccuracy: true,
          timeout: 30000,
          maximumAge: 0
        }
      );
    } else {
      // If browser does not support geolocation
      this.toastService.showErrorToast('Geolocation is not supported by your browser.');

      // Call API with null values
      this.storeLatitudeMap = null;
      this.storeLongitudeMap = null;
      this.getAggregatorSetup();
    }
  }

  aggregatorSetup: any[] = [];
  getAggregatorSetup() {
    this.getAggregatorSetupSubscription = this.productService.getAggregatorSetup(this.apiFactory.getAggregatorSetupByUrl,
      this.currentUrl, this.storeLatitudeMap != null ? this.storeLatitudeMap.toString() : null, this.storeLongitudeMap != null ? this.storeLongitudeMap.toString() : null)
      .subscribe(data => {
        console.log(data);
        this.aggregatorSetup = data;
        // if (data.length > 0) {
        //   this.storeLocationList = data;
        //   this.nearestLocationList = data.length > 0 ? data.slice(0, 5) : [];
        //   this.filteredLocations = this.storeLocationList;
        // } else {
        //   this.toastService.showErrorToast('No store for pickup');
        // }
      });
  }

  getCartProduct() {
    this.googleCustomer = JSON.parse(this.localStorage.getItem("google_loggedIn_details"));
    if (!this.googleCustomer) {
      return;
    }

    this.cartSetUpSubscription = this.cartService.getProductCart(this.apiFactory.getProductCart, this.googleCustomer.email, this.currentUrl)
      .subscribe((data: any) => {
        if (data != null) {
          this.cartList = data.product;
          this.localStorage.setItem("avct_item", JSON.stringify(this.cartList));
        }
      });
    this.getVisitorCount();
  }

  getVisitorCount() {
    this.cartSubscription = this.cartService.cart$.subscribe(() => {
      this.cartCount = this.cartService.getCartCount();
    });
  }

  getOfferClasses(offer: Offer): string {
    let classes = offer.bgColor;
    if (offer.border) {
      classes += ' border border-gray-200';
    }
    return classes;
  }

  // scrollOffers(direction: 'left' | 'right') {
  //   if (this.offersContainer) {
  //     const scrollAmount = direction === 'left' ? -200 : 200;
  //     this.offersContainer.nativeElement.scrollBy({ left: scrollAmount, behavior: 'smooth' });
  //   }
  // }

  // scrollOffers(direction: 'left' | 'right') {
  //   const el = this.offersContainer.nativeElement;
  //   const scrollAmount = 150;

  //   el.scrollBy({
  //     left: direction === 'left' ? -scrollAmount : scrollAmount,
  //     behavior: 'smooth'
  //   });

  //   // Delay needed because scroll is async
  //   setTimeout(() => this.checkScrollButtons(), 200);
  // }

  // checkScrollButtons() {
  //   const el = this.offersContainer.nativeElement;

  //   this.showLeft = el.scrollLeft > 0;
  //   this.showRight = el.scrollLeft + el.clientWidth < el.scrollWidth;
  // }

}